import { initializeSessionReplay } from '@/core/session-replay';

/**
 * Vue plugin for PostHog session replay.
 * Initializes session replay on app startup (all platforms).
 */
export const SessionReplayPlugin = {
  async install(): Promise<void> {
    await initializeSessionReplay();
  },
};
